import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { colors } from "@material-ui/core";
import InvTotal from "../../AFReadyDisigen/A4/InvTotal";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { getcolor } from "../../invCompany/A4/UnderHeader";
import  "../invoiceprint.css"
import { cellSName, styleNo } from "../../ShareFunctionsPrint";

const BodyInv = (props) => {
  const cls = useRptAF();
  const {  data, isLast, inv, sta ,locInv,premiApp} = props;


  const st_name = {
    width: "32%",
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    fontSize: "14px",
    border: "solid 0.1px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: 1.5,
    overflowWrap: "anywhere",
  }
  const num = Number(locInv?.largeNum);

  const showBar=  [12,6,16,19].includes(num); 
 
  var columns = [
    { title: "No \n م", field: "no", cellStyle: styleNo },
    { title: "Barcode \n الباركود", field: "barcode", hidden:showBar?true:false },
    { title: "Item Name \n اسم الصنف", field:  "symbol", cellStyle: st_name },
    { title: "Unit \n الوحدة", field: "unit_name", hidden:showBar?false:true },
    { title: "Quantity \n الكمية ", field: "val1", },
    { title: "Price \n سعر الوحدة", field: "new_exchange_price", },
    { title: "Discount \n الخصم", field: "discount", },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill",},
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval",},
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr",  },
  ];
  var columns31 = [
    { title: "No \n م", field: "no" ,cellStyle: styleNo},
    { title: "Barcode \n الباركود", field: "barcode", hidden: num === 31 ? true : false },
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: num ? st_name : cellSName },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n السعر ", field: "new_exchange_price", },
    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  var columns12 = [
    { title: "Description \n الوصف", field: "notes_details", cellStyle: cellSName },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n سعر الوحدة", field: "new_exchange_price", },
    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];
  var columns15 = [
    { title: "No \n م", field: "no" },
    { title: "Description \n الوصف", field: "notes_detailsItems", cellStyle: cellSName},
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n سعر الوحدة", field: "new_exchange_price", },
    { title:"BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  const cellSD4 = {
    textAlign: "-webkit-center",
    margin: "0px",
    border: "solid 0.1px",
    fontSize: "0.75rem",
    width: "33%",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    direction: "rtl",
    textAlign: "right",
    paddingRight: "5px",
    paddingTop: "0px",
    paddingBottom: "0px"
  };
  var columns17 = [
    { title: "No \n م", field: "no" ,cellStyle:styleNo},
    { title: "Description \n الوصف", field: "notesall", cellStyle: cellSD4 },
    { title: "Qoantity \n الكمية ", field: "val1" },
    { title: "Price \n سعر الوحدة", field: "new_exchange_price", },
    { title:"BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];
  var columnsCar = [
    { title: "No \n م", field: "no" ,cellStyle:styleNo },
    { title: "Service \n الخدمة", field: "symbol", cellStyle: cellSName },
    { title: "Unit Name \n الوحدة", field: "unit_name" },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Service Price \n سعر الخدمة", field: "new_exchange_price", },
    { title: "BeforeVat \n  الخاضع للضريبة", field: "totBill" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];
  const invColors = sta?.StngIA?.colors;
  const secondColor = getcolor(invColors);
  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
        style={{
          paddingTop: "0.5rem", direction: "rtl", border: "dotted 1px #393939",
        }}>
        <Grid
          container
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none",tableLayout:"fixed",width:"100%" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: num === 17 ||num=== 20 ? secondColor : colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={num === 12 ? (columns12.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : num === 15 ? (columns15.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : num === 17 ? (columns17.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : num === 31 ? (columns31.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) :num === 14 ? (columnsCar.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))):
              (columns.map(column => ({
                ...column,
                title: column.title.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                )),

              })))}
            data={data}
          />
          {isLast && <InvTotal inv={inv} sta={sta} locInv={locInv} premiApp={premiApp}/>}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BodyInv;
